import { useGetTeamsQuery } from 'common/store/modules/api/afl-api';

export const getId = (cell, row) =>
    `brownlow-leaderboard-${row.original.player.givenName}-${row.original.player.surname}-${cell.column.id}`;

export const getTitle = (cell, row) =>
    `${row.original.player.givenName} ${row.original.player.surname}: ${
        cell.value.actual ? cell.value.actual : 'No'
    } votes.`;

export const useTeamsList = (seasonId) => {
    const { data: [...teamsList] = [] } = useGetTeamsQuery(seasonId, {});
    return teamsList;
};

/**
 * Builds a comp-aware GA tracking label for the Brownlow/B&F predictor
 * e.g. getPredictorTrackingLabel(true, 'player pin') -> 'aflw b&f player pin'
 *
 * @param {boolean} isAFLW
 * @param {string} suffix
 * @returns {string}
 */
export const getPredictorTrackingLabel = (isAFLW, suffix) =>
    `${isAFLW ? 'aflw b&f' : 'brownlow'} ${suffix}`;

/**
 * Resolves whether a given seasonPid belongs to the AFLW competition
 *
 * @param {string} seasonPid
 * @returns {boolean}
 */
export const getIsAFLW = (seasonPid) =>
    PULSE.app.common.match.getCompAbbr(seasonPid)?.toLowerCase() === 'aflw';
